/* global $ */
import React, { Component } from 'react';

class OwlCarousel extends Component {
    componentDidMount() {
        console.log('Event:OwlCarousel:mount');
        this.initialiseCarousel();
    }
    componentDidUpdate() {
        console.log('Event:OwlCarousel:update');
        console.log(this.$carouselElement);
        if(!this.$carouselElement.is('.owl-carousel')) {
            console.log('ReINit: owlCarousel');
            this.initialiseCarousel();
        }
        // 'owl-carousel'
    }
    initialiseCarousel() {
        this.$carouselElement.owlCarousel(this.props.options);
    }
    render() {
        let { options, children, ...props } = this.props;

        return (
            <div {...props} ref={div => (this.$carouselElement = $(div))}>
                {children}
            </div>
        );
    }
}

export default OwlCarousel;



// WEBPACK FOOTER //
// ./src/components/owlCarousel/OwlCarousel.jsx